/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_About_StoryInputs */

const en_label_about_story = /** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const es_label_about_story = /** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra Historia`)
};

const fr_label_about_story = /** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre histoire`)
};

const de_label_about_story = /** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Geschichte`)
};

const id_label_about_story = /** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerita Kami`)
};

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const ja_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const zh_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const ar_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const it_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const ru_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const pt_label_about_story = en_label_about_story;

/** @type {(inputs: Label_About_StoryInputs) => LocalizedString} */
const ko_label_about_story = en_label_about_story;

/**
* | output |
* | --- |
* | "Our Story" |
*
* @param {Label_About_StoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_about_story = /** @type {((inputs?: Label_About_StoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_About_StoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_about_story(inputs)
	if (locale === "es") return es_label_about_story(inputs)
	if (locale === "fr") return fr_label_about_story(inputs)
	if (locale === "de") return de_label_about_story(inputs)
	if (locale === "ja") return ja_label_about_story(inputs)
	if (locale === "zh") return zh_label_about_story(inputs)
	if (locale === "ar") return ar_label_about_story(inputs)
	if (locale === "id") return id_label_about_story(inputs)
	if (locale === "it") return it_label_about_story(inputs)
	if (locale === "ru") return ru_label_about_story(inputs)
	if (locale === "pt") return pt_label_about_story(inputs)
	return ko_label_about_story(inputs)
});